import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import princ from "../assets/staff/princ.jpg";
import img1 from "../assets/cover1.jpeg";
import img2 from "../assets/cover2.jpeg";
import img3 from "../assets/cover3.jpeg";
import img4 from "../assets/cover4.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../App.css";

const API_BASE = "http://dietdubacherla.in/diet_backend";
const defaultHeroSlides = [img1, img2, img3, img4];

const quickLinks = [
  ["e-Pathasala", "https://apepathasala.ap.gov.in/Home.aspx"],
  ["CSE AP", "https://cse.ap.gov.in/"],
  ["DIKSHA", "https://diksha.gov.in/"],
  ["NCERT", "https://ncert.nic.in/textbook.php"],
  ["AP TET DSC", "https://tet2dsc.apcfss.in/"],
  ["AP DEECET", "https://apdeecet.apcfss.in/"]
  
];

const quickLinkColors = ["#fb923c", "#6d5bd0", "#c957a9", "#0b84f3", "#6b7280", "#22a547", "#f4b400"];

const stats = [
  ["30+", "Years of academic service"],
  ["5000+", "Teachers trained"],
  ["100%", "NCTE approved programs"],
  ["50+", "Workshops and training events"],
];

const programs = [
  ["D.El.Ed", "A structured diploma program focused on elementary education, classroom practice, and foundational pedagogy."],
  ["In-Service Training", "Professional development programs for teachers, mentors, and school education personnel."],
  ["Academic Workshops", "Skill-building sessions, resource orientation, seminars, and curriculum-based training."],
];

const facilities = [
  ["Library", "Learning resources, reference books, journals, and academic reading support."],
  ["Computer Lab", "Digital learning support for student teachers and training programs."],
  ["Smart Classrooms", "Technology-enabled teaching spaces for modern classroom practice."],
  ["Sports and Activities", "Spaces for physical education, events, and student engagement."],
  ["Girls Hostel", "A safe, secure, and comfortable student maintained residential facility for girls."]
];

export default function Home() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [homeSlides, setHomeSlides] = useState(defaultHeroSlides);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetch(`${API_BASE}/get_home_slider.php`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setHomeSlides(data.map((slide) => slide.image_url));
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: !isMobile,
    pauseOnHover: false,
  };

  return (
    <main style={styles.page}>
      <section style={{ ...styles.hero, ...(isMobile ? styles.heroMobile : {}) }}>
        <div style={styles.heroSliderCard}>
          {/* <div style={{ ...styles.heroRibbon, ...(isMobile ? styles.heroRibbonMobile : {}) }}>
            Official Website of DIET Dubacherla
          </div> */}
          <div style={styles.heroMedia}>
            <Slider {...settings}>
              {homeSlides.map((img, index) => (
                <div key={img}>
                  <img src={img} alt={`DIET campus ${index + 1}`} style={styles.heroImage} />
                </div>
              ))}
            </Slider>
          </div>
        </div>

        <aside style={{ ...styles.quickPanel, ...(isMobile ? styles.quickPanelMobile : {}) }}>
          <div style={styles.quickPanelHeader}>
            <span>Quick Links</span>
          </div>
          <div style={styles.quickList}>
            {quickLinks.map(([name, url], index) => (
              <a
                key={`${name}-${index}`}
                href={url}
                target="_blank"
                rel="noreferrer"
                style={{ ...styles.quickLink, background: quickLinkColors[index % quickLinkColors.length] }}
              >
                {name}
              </a>
            ))}
          </div>
        </aside>
      </section>

      <section style={styles.introBand}>
        <div>
          <p style={styles.eyebrow}>District Institute of Education and Training</p>
          <h1 style={{ ...styles.heroTitle, ...(isMobile ? styles.heroTitleMobile : {}) }}>
            DIET Dubacherla
          </h1>
          <p style={{ ...styles.heroText, ...(isMobile ? styles.heroTextMobile : {}) }}>
            A dedicated teacher education institution focused on academic excellence,
            professional training, and meaningful classroom practice.
          </p>
        </div>
        <div style={{ ...styles.heroActions, ...(isMobile ? styles.heroActionsMobile : {}) }}>
          <button style={styles.primaryButton} onClick={() => navigate("/about")}>
            Explore Institute
          </button>
          <button style={styles.secondaryButton} onClick={() => navigate("/downloads")}>
            View Downloads
          </button>
        </div>
      </section>

      <section style={{ ...styles.statsBand, ...(isMobile ? styles.statsBandMobile : {}) }}>
        {stats.map(([number, label]) => (
          <div key={label} style={styles.statItem}>
            <strong style={styles.statNumber}>{number}</strong>
            <span style={styles.statLabel}>{label}</span>
          </div>
        ))}
      </section>

      <section style={styles.section}>
        <div style={styles.sectionIntro}>
          <p style={styles.sectionKicker}>About The Institute</p>
          <h2 style={styles.sectionTitle}>Preparing teachers for stronger classrooms</h2>
          <p style={styles.sectionText}>
            DIET Dubacherla supports teacher education through training, academic
            guidance, professional development, and student-centered learning
            practices that serve schools and communities.
          </p>
        </div>

        <div style={{ ...styles.infoGrid, ...(isMobile ? styles.infoGridMobile : {}) }}>
          <InfoCard title="Academic Focus" text="Teacher education, foundational pedagogy, classroom readiness, and curriculum understanding." />
          <InfoCard title="Training Culture" text="Workshops, orientation programs, school support activities, and continuous professional learning." />
          <InfoCard title="Student Support" text="A structured environment for student teachers to learn, practice, collaborate, and grow." />
        </div>
      </section>

      <section style={{ ...styles.splitSection, ...(isMobile ? styles.splitSectionMobile : {}) }}>
        <div>
          <p style={styles.sectionKicker}>Programs</p>
          <h2 style={styles.sectionTitle}>Courses and training areas</h2>
          <p style={styles.sectionText}>
            The institute combines formal teacher education with practical training
            opportunities that support both student teachers and working educators.
          </p>
          <button style={styles.inlineButton} onClick={() => navigate("/downloads")}>
            Open Academic Downloads
          </button>
        </div>

        <div style={styles.programList}>
          {programs.map(([title, text]) => (
            <InfoCard key={title} title={title} text={text} />
          ))}
        </div>
      </section>

      <section style={styles.sectionAlt}>
        <div style={styles.sectionIntro}>
          <p style={styles.sectionKicker}>Campus Facilities</p>
          <h2 style={styles.sectionTitle}>Learning spaces built for teacher preparation</h2>
        </div>

        <div style={{ ...styles.facilityGrid, ...(isMobile ? styles.infoGridMobile : {}) }}>
          {facilities.map(([title, text]) => (
            <InfoCard key={title} title={title} text={text} compact />
          ))}
        </div>
      </section>

      <section style={{ ...styles.principalSection, ...(isMobile ? styles.principalSectionMobile : {}) }}>
        <img src={princ} alt="Principal" style={styles.principalImage} />
        <div>
          <p style={styles.sectionKicker}>Leadership Message</p>
           <h3 >M Kamala Kumari, Principal</h3>
          
         
          <p style={styles.principalText}>
            DIET Dubacherla is committed to building competent, responsible, and
            reflective teachers. Our focus is to provide quality teacher education
            supported by discipline, innovation, and service to society.
          </p>
          <div style={{ ...styles.heroActions, ...(isMobile ? styles.heroActionsMobile : {}) }}>
            <button style={styles.primaryButton} onClick={() => navigate("/faculty")}>
              View Faculty
            </button>
            <button style={styles.secondaryButtonLight} onClick={() => navigate("/contact")}>
              Contact Us
            </button>
          </div>
        </div>
      </section>

      <footer style={styles.footer}>
        <strong>DIET Dubacherla</strong>
        <span>Copyright 2026. All Rights Reserved.</span>
     <span style={styles.designer}>
  Designed & Developed by Ch. P. Divyamshi
  <br />
  Technical Support: 
  <a
    href="mailto:padmajadivyamshi@gmail.com"
    style={{ color: "#a99dbd", textDecoration: "none" }}
  >
      padmajadivyamshi@gmail.com
  </a>
</span>
      </footer>
    </main>
  );
}

function InfoCard({ title, text, compact = false }) {
  return (
    <article style={{ ...styles.infoCard, ...(compact ? styles.compactCard : {}) }}>
      <h3 style={styles.cardTitle}>{title}</h3>
      <p style={styles.cardText}>{text}</p>
    </article>
  );
}

const styles = {
   designer: {
    marginLeft: "auto",
    textAlign: "right",
  },
  page: {
    minHeight: "100vh",
    background: "#f3f4f6",
    color: "#111827",
    fontFamily: "Inter, Arial, sans-serif",
  },
  hero: {
    maxWidth: "1320px",
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 305px",
    alignItems: "start",
    gap: "28px",
    padding: "26px 18px 10px",
  },
  heroMobile: {
    display: "block",
    padding: "14px",
  },
  heroSliderCard: {
    position: "relative",
    background: "white",
    borderRadius: "8px",
    padding: "12px",
    boxShadow: "0 10px 28px rgba(15,23,42,0.18)",
    overflow: "hidden",
  },
  heroRibbon: {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 2,
    minWidth: "330px",
    background: "#1976d2",
    color: "white",
    padding: "14px 20px",
    borderBottomLeftRadius: "0",
    fontSize: "14px",
    fontWeight: "900",
    textAlign: "center",
  },
  heroRibbonMobile: {
    left: "12px",
    right: "12px",
    minWidth: "auto",
    padding: "11px 12px",
    fontSize: "12px",
  },
  heroMedia: {
    border: "2px solid white",
    overflow: "hidden",
  },
  heroImage: {
    width: "100%",
    height: "380px",
    objectFit: "cover",
    display: "block",
  },
  introBand: {
    maxWidth: "1180px",
    margin: "10px auto 0",
    padding: "20px 24px 8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
    flexWrap: "wrap",
  },
  eyebrow: {
    margin: "0 0 12px",
    color: "#991b1b",
    fontWeight: "900",
    fontSize: "13px",
    textTransform: "uppercase",
    letterSpacing: "0",
  },
  heroTitle: {
    margin: 0,
    color: "#111827",
    fontSize: "38px",
    lineHeight: 1.02,
    letterSpacing: "0",
  },
  heroTitleMobile: {
    fontSize: "30px",
  },
  heroText: {
    maxWidth: "660px",
    margin: "18px 0 0",
    color: "#4b5563",
    fontSize: "16px",
    lineHeight: 1.7,
  },
  heroTextMobile: {
    fontSize: "16px",
  },
  heroActions: {
    display: "flex",
    gap: "12px",
    marginTop: "28px",
    flexWrap: "wrap",
  },
  heroActionsMobile: {
    display: "grid",
    gridTemplateColumns: "1fr",
  },
  primaryButton: {
    background: "#b91c1c",
    color: "white",
    border: "none",
    padding: "13px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "900",
    fontSize: "14px",
  },
  secondaryButton: {
    background: "white",
    color: "#7f1d1d",
    border: "1px solid #fecaca",
    padding: "13px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "900",
    fontSize: "14px",
  },
  secondaryButtonLight: {
    background: "white",
    color: "#7f1d1d",
    border: "1px solid #fecaca",
    padding: "13px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "900",
    fontSize: "14px",
  },
  quickPanel: {
    height: "405px",
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "4px",
    boxShadow: "0 8px 24px rgba(15,23,42,0.14)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  quickPanelMobile: {
    marginTop: "18px",
    height: "300px",
  },
  quickPanelHeader: {
    padding: "16px",
    background: "#86a64b",
    color: "white",
    fontWeight: "900",
  },
  quickList: {
    display: "grid",
    gap: "10px",
    padding: "14px",
    overflowY: "auto",
  },
  quickLink: {
    textDecoration: "none",
    color: "white",
    background: "#1976d2",
    border: "none",
    borderRadius: "999px",
    padding: "11px 14px",
    fontWeight: "800",
  },
  statsBand: {
    maxWidth: "1180px",
    margin: "24px auto 0",
    position: "relative",
    zIndex: 2,
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "1px",
    background: "#e5e7eb",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 18px 45px rgba(15,23,42,0.14)",
  },
  statsBandMobile: {
    margin: "0 14px",
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  statItem: {
    background: "white",
    padding: "22px",
    display: "grid",
    gap: "6px",
    textAlign: "center",
  },
  statNumber: {
    color: "#991b1b",
    fontSize: "30px",
  },
  statLabel: {
    color: "#6b7280",
    fontWeight: "800",
    fontSize: "13px",
  },
  section: {
    maxWidth: "1180px",
    margin: "0 auto",
    padding: "70px 24px",
  },
  sectionAlt: {
    background: "white",
    padding: "70px 24px",
  },
  sectionIntro: {
    maxWidth: "760px",
    margin: "0 auto 30px",
    textAlign: "center",
  },
  sectionKicker: {
    margin: "0 0 8px",
    color: "#991b1b",
    fontSize: "12px",
    fontWeight: "900",
    textTransform: "uppercase",
  },
  sectionTitle: {
    margin: 0,
    color: "#111827",
    fontSize: "32px",
    lineHeight: 1.25,
  },
  sectionText: {
    margin: "14px 0 0",
    color: "#4b5563",
    fontSize: "16px",
    lineHeight: 1.75,
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "18px",
  },
  infoGridMobile: {
    gridTemplateColumns: "1fr",
  },
  infoCard: {
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "24px",
    boxShadow: "0 1px 2px rgba(15,23,42,0.05)",
  },
  compactCard: {
    background: "#f9fafb",
  },
  cardTitle: {
    margin: "0 0 10px",
    color: "#111827",
    fontSize: "18px",
  },
  cardText: {
    margin: 0,
    color: "#4b5563",
    lineHeight: 1.65,
  },
  splitSection: {
    maxWidth: "1180px",
    margin: "0 auto",
    padding: "20px 24px 70px",
    display: "grid",
    gridTemplateColumns: "0.9fr 1.1fr",
    gap: "28px",
    alignItems: "start",
  },
  splitSectionMobile: {
    gridTemplateColumns: "1fr",
  },
  programList: {
    display: "grid",
    gap: "14px",
  },
  inlineButton: {
    marginTop: "22px",
    background: "#111827",
    color: "white",
    border: "none",
    padding: "12px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "900",
  },
  facilityGrid: {
    maxWidth: "1180px",
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "16px",
  },
  principalSection: {
    maxWidth: "1180px",
    margin: "0 auto",
    padding: "70px 24px",
    display: "grid",
    gridTemplateColumns: "260px 1fr",
    gap: "34px",
    alignItems: "center",
  },
  principalSectionMobile: {
    gridTemplateColumns: "1fr",
    textAlign: "center",
    padding: "50px 18px",
  },
  principalImage: {
    width: "240px",
    height: "240px",
    borderRadius: "8px",
    objectFit: "cover",
    border: "6px solid white",
    boxShadow: "0 18px 45px rgba(15,23,42,0.18)",
  },
  principalText: {
    margin: "16px 0 0",
    color: "#4b5563",
    fontSize: "16px",
    lineHeight: 1.8,
  },
  footer: {
    background: "#111827",
    color: "white",
    padding: "20px 24px",
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    flexWrap: "wrap",
    fontSize: "14px",
  },
};
